<template>
    <div id="CookieConsentBlock">
      <div class="block_wrapper">
        <div class="block_text">
          <ul>
            <li>
              We use cookies to help us better understand how the site is used and to enable you to share content on social networks.
          </li>
          <li>
              We retain your choice for 6 months. You can change your mind at any time by clicking on the "manage cookies" button at the bottom of any page.
          </li>
          <li>
            By <a @click="refuseCookies()">closing this panel</a>, you refuse all cookies.
          </li>
      </ul>
    </div>
    <div class="block_buttons">
      <a class="block_bt bt_accept" @click="activateGTag();">Accept all</a>
      <a class="block_bt bt_refuse" @click="refuseCookies();">Refuse all</a>
    </div>
</div>
</div>
</template>


<script>

    export default {
      props: ["page"],
      data: function () {
        return {
            localStorageID: "pse-atlas"
        }
    },

    mounted: function () {
        this.loadLocalStorage()
    },

    methods: {

        loadLocalStorage: function () {
            var localPSEData = localStorage.getItem(this.localStorageID);

            if(localPSEData == null || localPSEData == undefined) {
                document.querySelector("#CookieConsentBlock").setAttribute("data-displayed", "displayed");
            } else if(localPSEData == "true") {
                this.activateGTag();
            }
        },

        activateGTag: function (){
            localStorage.setItem(this.localStorageID, "true");
            this.hideConsentBlock();
        },

        hideConsentBlock: function (){
            document.querySelector("#CookieConsentBlock").setAttribute("data-displayed", "hidden");
        },

        showConsentBlock: function(){
            document.querySelector("#CookieConsentBlock").setAttribute("data-displayed", "displayed");
        },

        refuseCookies: function (){
            localStorage.setItem(this.localStorageID, "false");
            this.hideConsentBlock();
        },

        openCookies: function () {
            this.showConsentBlock();
        }
    }
}
</script>

<style lang="scss" scoped>
@import "~assets/scss/_variables.scss";
@import "~assets/scss/_browsers.scss";

#CookieConsentBlock{
    position: fixed;
    left: 0px;
    bottom: 0px;
    height: auto;
    background: #29264c;
    z-index: 1000000;
    font-family: "Roboto",sans-serif;
    width: 100%;
    display: none;
    text-align: center;
    box-shadow: 10px 0px 20px #000;
}
#CookieConsentBlock .block_wrapper{
    display: inline-block;
    text-align: left;
    width: 100%;
    max-width: 1200px;
    padding: 20px;
    position: relative;
}
#CookieConsentBlock[data-displayed="displayed"]{
    display: block;
}
#CookieConsentBlock[data-forcehidden="true"]{
    display: none !important;
}
#CookieConsentBlock .block_text{
    color: #fff;
    position: relative;
    max-width: 70%;
    font-size: 14px;
    line-height: 17px;
}
#CookieConsentBlock .block_text a{
    color: #fff;
    cursor: pointer;
    text-decoration: underline;
}
#CookieConsentBlock .block_text li{
    margin-bottom: 10px;
}
#CookieConsentBlock .block_buttons{
    position: absolute;
    right: 20px;
    top: 20px;
    transform:translate(0, 0);
}
#CookieConsentBlock .block_buttons .block_bt{
    width: 124px;
    display: inline-block;
    background: $colorOrange;
    height: 24px;
    line-height: 24px;
    color: #fff;
    border-radius: 4px;
    cursor: pointer;
    padding-left: 10px;
    position: relative;
    margin-left: 6px;
    font-size: 14px;
    font-family: "Roboto";
    font-weight: bold;
}
#CookieConsentBlock .block_buttons .block_bt:after{
    position: absolute;
    right: 0px;
    top: 50%;
    transform:translate(0, -50%);
    content: "";
}
.block_bt.bt_accept:after{
    background:url("/images/icon-btn-valid-white.svg") no-repeat center center transparent;
    background-size: 100% 100%;
    width: 24px;
    height: 24px;
}
.block_bt.bt_refuse:after{
    background:url("/images/icon-btn-close-white.svg") no-repeat center center transparent;
    background-size: 100% 100%;
    width: 38px;
    height: 38px;
}

</style>


// WEBPACK FOOTER //
// components/cookiesConsent.vue